import { render, staticRenderFns } from "./PatientBuildingSection.vue?vue&type=template&id=51b2a474&"
import script from "./PatientBuildingSection.vue?vue&type=script&lang=js&"
export * from "./PatientBuildingSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports